/**
 * カルーセルイメージブロックのフロントエンド用JavaScript
 *
 * splideとsplide-extension-auto-scrollを使用して
 * 画像の自動スクロールカルーセルを実装します。
 *
 * @see https://splidejs.com/
 * @see https://github.com/Splidejs/splide-extension-auto-scroll
 */

import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  /**
   * カルーセルを初期化する
   *
   * @param {HTMLElement} element - splide要素
   */
  async function initCarousel(element) {
    // data-speed属性から速度を取得
    const speed = parseInt(element.getAttribute("data-speed"), 10) || 10;

    const speedVal = speed / 10;

    // splideインスタンスを作成
    const splide = new Splide(element, {
      type: "loop",
      pagination: false,
      arrows: false,
      autoWidth: true,
      drag: false,
      autoScroll: {
        speed: speedVal,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    });

    // auto-scroll拡張をマウント
    splide.mount({ AutoScroll });

    return splide;
  }

  /**
   * すべてのカルーセル要素を初期化
   */
  async function initAllCarousels() {
    const carousels = document.querySelectorAll(
      ".wp-block-scd-block-carousel-image .splide",
    );

    if (carousels.length === 0) {
      return;
    }

    // すべてのカルーセルを初期化
    const promises = Array.from(carousels).map((carousel) =>
      initCarousel(carousel),
    );

    await Promise.all(promises);
  }

  // DOMContentLoaded時に初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllCarousels);
  } else {
    initAllCarousels();
  }
});
